/**
 * MSS Commercial Value accordion: one item open at a time; the side image follows the open item.
 * Buttons carry aria-expanded; panels use [hidden]. Closing the open item keeps its image.
 */
(() => {
  const init = (root) => {
    const items = Array.from(root.querySelectorAll('[data-mss-commercial-item]'));
    const figures = Array.from(root.querySelectorAll('[data-mss-commercial-figure]'));

    const setOpen = (item, open) => {
      const toggle = item.querySelector('[data-mss-commercial-toggle]');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) {
        panel.hidden = !open;
      }
    };

    items.forEach((item, index) => {
      item.querySelector('[data-mss-commercial-toggle]')?.addEventListener('click', () => {
        const opening = !item.classList.contains('is-open');

        items.forEach((other) => setOpen(other, other === item && opening));

        if (opening) {
          figures.forEach((figure, i) => figure.classList.toggle('is-active', i === index));
        }
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-mss-commercial]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
